import request from './.request'

/**
 * 根据id获取一个种植方案的详细内容
 * @param {number} id
 * @returns
 */
export function getSchemeDetailById(id) {
  return request({
    url: `/plant-scheme/${id}`,
    method: 'get',
  })
}

//查询
export function getProgrammeData(e) {
  return request({
    url: `/plant-scheme`,
    method: 'get',
    params: e
  })
}
//根据id查询唯一一条数据
export function getProgrammeDataById(id) {
  return request({
    url: `/plant-scheme/${id}`,
    method: 'get',
  })
}

//添加
export function addProgrammeData(e) {
  return request({
    url: `/plant-scheme`,
    method: 'post',
    data: e
  })
}
//删除
export function delProgrammeData(e) {
  return request({
    url: `/plant-scheme/` + e,
    method: 'delete',
  })
}
//修改
export function updateProgrammeData(e) {
  return request({
    url: `/plant-scheme`,
    method: 'put',
    data: e
  })
}
//查询适用于某个品种的种植方案
export function getProgrammeDataByVarietyId(varietyId) {
  return request({
    url: `/plant-scheme/${varietyId}?by=variety`,
    method: 'get',
  })
}



// WEBPACK FOOTER //
// ./src/api/programme.js